import React from 'react'
import Head from "next/head";
import SchemaTags from "@/components/common/SchemaTags";
import Bookstores from '@/components/outlet/Bookstores';

const bookstores = () => {
  return (
    <>
      <Head>
        <title>Best POS Billing Software for Bookstores | Bookshop POS System India</title>
        <link rel="canonical" href="https://queuebuster.co/outlet/book-stores-pos-billing-software" />
        <link rel="alternate" href="https://queuebuster.co/outlet/book-stores-pos-billing-software" hrefLang="en-us" />
        <meta name="description" content="Boost your bookstore’s efficiency with QueueBuster – the best POS billing software for bookstores. Manage sales, inventory, GST billing & customer loyalty in one smart POS system." />
        <meta property="og:title" content="Top POS Billing Software for Bookstores | Bookshop POS India" />
        <meta property="og:description" content="Looking for billing software for your book shop? Try QueueBuster – the all-in-one bookstore POS with GST-ready billing, inventory control & loyalty programs." />
        <meta property="og:image" content="https://quebuster.s3.ap-south-1.amazonaws.com/website/assets/OG+Images-03.png" />
        <meta property="og:url" content="https://queuebuster.co/outlet/book-stores-pos-billing-software" />
        <meta property="og:type" content="website" />

      </Head>
         <SchemaTags page="book-stores-pos-billing-software" />
      <Bookstores/>
    </>
  )
}

export default bookstores